import React from "react";
import { Paper, Typography } from "@mhome/ui";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import { alpha } from "@mui/material/styles";

const SystemMessage = ({ message, type = "info" }) => {
  const getIcon = () => {
    const iconColors = {
      warning: "hsl(var(--yellow-500))",
      error: "hsl(var(--destructive))",
      info: "hsl(var(--blue-500))",
    };
    const color = iconColors[type] || iconColors.info;

    switch (type) {
      case "warning":
        return <WarningIcon style={{ color }} />;
      case "error":
        return <ErrorIcon style={{ color }} />;
      default:
        return <InfoIcon style={{ color }} />;
    }
  };

  const getBackgroundColor = () => {
    const colors = {
      warning: "hsl(var(--yellow-500))",
      error: "hsl(var(--destructive))",
      info: "hsl(var(--blue-500))",
    };
    const color = colors[type] || colors.info;
    return alpha(color, 0.1);
  };

  return (
    <div style={{ marginBottom: "16px" }}>
      <Paper
        elevation={0}
        style={{
          padding: "16px",
          backgroundColor: getBackgroundColor(),
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {getIcon()}
          <Typography
            variant="body2"
            color="muted"
            style={{
              fontStyle: "italic",
            }}
          >
            {message}
          </Typography>
        </div>
      </Paper>
    </div>
  );
};

export default SystemMessage;
